<template>
  <div class="page-content container-fluid">
    <div class="row">
      <div class="col-12">
        <h5 class="text-uppercase">Deleted presentation(s)</h5>

        <div class="card">
          <div class="card-body table-content">
            <table class="table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th class="w-300px">Name</th>
                  <th>Access code</th>
                  <th>Unique access code</th>
                  <th>Created date</th>
                  <th>Last modified date</th>
                  <th>Deleted date</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody v-if="!isPresentationLoading && presentations.length !== 0">
                <PresentationRow
                  v-for="presentation in presentations"
                  :key="presentation.id"
                  :presentation="presentation"
                  :handleRecoverPresentation="handleRecoverPresentation"
                />
              </tbody>
            </table>

            <div
              class="d-flex justify-content-center"
              v-if="isPresentationLoading"
            >
              Loading...
            </div>

            <div
              v-if="!isPresentationLoading && presentations.length === 0"
            >
              <h5
                class="text-center font-medium"
                style="line-height: 35px;"
              >
                <span>
                  User doesn't have any deleted presentation yet.
                </span>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import configs from '../../config'

// component
import PresentationRow from './PresentationRow.vue'

export default {
  components: {
    PresentationRow,
  },
  data() {
    return {
      presentations: [],
      isPresentationLoading: false,
    }
  },
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  async mounted() {
    this.isPresentationLoading = true
    const res = await this.$http.get(configs.api.getDeletedPresentations, {
      params: {
        userId: this.userId,
        limit: 100,
      },
    })
    this.presentations = res.body.result
    this.isPresentationLoading = false
  },
  methods: {
    handleRecoverPresentation(presentationId) {
      this.presentations = this.presentations.filter((item) => item.id !== presentationId)
    },
  },
}
</script>
